import { NgModule } from '@angular/core';
import { ToolbarmodelComponent } from './toolbarmodel.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';


@NgModule({
    imports: [CommonModule,FormsModule],
   exports: [ToolbarmodelComponent],
   declarations: [ToolbarmodelComponent],
   providers: [],
})
export class ToolbarmodelModule{ }